export var colorFromIndex = function colorFromIndex(index) {
  var idx = index % 9 + 1;
  return idx <= 4 ? "accent-" + idx : "neutral-" + (idx - 4);
};

export var colorForName = function colorForName(name, theme) {
  return theme.global.colors[name] || name;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/utils/colors.js
// module id = 206
// module chunks = 0